<template>
  <div id="app">
    <core-header/>
    <div class="flex justify-center">
      <router-view/>
    </div>
  </div>
</template>

<style lang="scss">
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #333;
}
#bot-nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #fff;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

html {
    height: 100vh;
    width: 100%;
}

html,
body {
/*    overflow: hidden;*/
    font-family: 'Helvetica Neue',Helvetica,Arial,sans-serif;
    color: white;
    background-size: auto;
    -webkit-background-size: 100%;
    background-repeat: repeat;
    line-height: 1.42857143;
}

.main-container {
  width: 500px;
}
.dot {
  height: 10px;
  width: 10px;
  border-radius: 50%;
}

.hymnal-name {
  font-size: 26px;
  font-weight: 400;
}

.hymnal-cover {
  max-width: 50px;
}

::placeholder {
  color: lightgray;
}

@media screen and (max-width: 450px) {
  .main-container {
    width: 100%;
  }
}

</style>
